import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import baseURL from '../Common/Config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCheck, faTimes, faChalkboardTeacher, faTrash,
    faHandshake, faClipboardCheck
} from '@fortawesome/free-solid-svg-icons';
import FailureAlert from '../Common/Failure';
import { ThemeContext } from '../Common/ThemeProvider';
import Select from 'react-select';
import DataTable from '../Common/DataTableList';
import moment from 'moment';

const Enquiry = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [FilterEnquiry, setFilterEnquiry] = useState([]);
    const [SelectedOrg, setSelectedOrg] = useState({ value: null, label: null });
    const [OrgList, setOrgList] = useState([]);
    const [displayAssignModal, setdisplayAssignModal] = useState("none");
    const [SelectedEnquiryID, setSelectedEnquiryID] = useState("");


    useEffect(() => {
        FetchEnquiries();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchEnquiries = () => {
        Axiosfetch(baseURL + "GetEnquiries", "GET", null, EnquiriesSuccess, Failure);
    };

    const hideAssignOrgView = () => {
        setdisplayAssignModal("none");
    };

    const EnquiriesSuccess = (data) => {
        if (data.length > 0) {
            setFilterEnquiry(data);
        }
        else {
            setFilterEnquiry([]);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const OnActionClick = (EnquiryID, processType, partnerID) => {
        if (EnquiryID !== "" && processType !== 0 && processType !== 1) {
            Axiosfetch(baseURL + "EditEnquiriesStatus", "POST", { ID: EnquiryID, Status: processType, PartnerID: partnerID }, EnquiriesUpdateSuccess, Failure);
        }
        else {
            Alert.error("Error Updating Enquiry. Refresh the page and try again.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const EnquiriesUpdateSuccess = (data) => {
        if (data.success) {
            FetchEnquiries();
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const onOrgListChange = (OrgData) => {
        if (OrgData) {
            setSelectedOrg(OrgData);
        }
        else {
            setSelectedOrg({ value: null, label: null });
        }
    };

    const onAssignOrg = (EnquiryID, EnquiryCity) => {
        if (EnquiryID !== "") {
            setSelectedEnquiryID(EnquiryID);
        }

        Axiosfetch(baseURL + "GetActiveOrganizationByCity", "POST", { Keywords: EnquiryCity }, CityListSuccess, Failure);
    };

    const CityListSuccess = (data) => {
        if (data && data.length > 0) {
            var partner = [];
            data.forEach(org => {
                if (((org.ExpiryDate === undefined || org.ExpiryDate === null) ||
                    (org.ExpiryDate !== "" && moment() < moment(org.ExpiryDate)))) {
                    partner.push({ value: org._id, label: org.Name + " [MFI " + org.City + "]" });
                }
            });

            setOrgList(partner);
            setdisplayAssignModal("block");
        }
        else {
            setOrgList([]);
            setdisplayAssignModal("none");
            Alert.error("Cannot process. No Partners found in the City.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OnEnquiryProcess = () => {
        if (SelectedEnquiryID !== "" && SelectedOrg && SelectedOrg.value !== null) {
            OnActionClick(SelectedEnquiryID, 2, SelectedOrg.value);
            setdisplayAssignModal("none");
        }
        else {
            Alert.error("Please Select Partner", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OnCloseEnquiry = (EnquiryID) => {
        Axiosfetch(baseURL + "CloseEnquiry", "POST", { ID: EnquiryID, Status: 4 }, CloseSuccess, Failure);
    };

    const CloseSuccess = (data) => {
        if (data.success) {
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            FetchEnquiries();
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const columns = [
        {
            name: 'Subject',
            wrap: true,
            selector: row => row.Subject,
            sortable: true,
        },
        {
            name: 'Destination',
            wrap: true,
            selector: row => `${row.Destination} [${row.City} ${row.State} ${row.Country} ]`,
            sortable: true,
        },
        {
            name: 'Type',
            selector: row => row.MoveType,
            sortable: true,
        },
        {
            name: 'Survey',
            width: "80px",
            selector: row => {
                return row.SurveyRequired === 1 ? (<span style={{ color: "green" }}><FontAwesomeIcon icon={faCheck} /></span>) :
                    (<span style={{ color: "red" }}><FontAwesomeIcon icon={faTimes} /></span>)
            }
        },
        {
            name: 'Assigned To',
            wrap: true,
            selector: row => { return <div style={{ whiteSpace: "normal" }}>{row.Partner.length > 0 ? row.Partner[0].Name : ""} </div> },
            sortable: true,
        },
        {
            name: 'Remarks',
            wrap: true,
            selector: row => row.Remarks,
            sortable: true,
        },
        {
            name: 'Agent',
            wrap: true,
            selector: row => row.Agent.length > 0 ? (row.Agent[0].FirstName + " " + row.Agent[0].LastName) : "",
            sortable: true,
        },
        {
            name: 'Created Date',
            wrap: true,
            selector: row => moment(row.createdAt).local().format("DD/MM/YYYY"),
            sortable: true,
        },
        {
            name: 'Action',
            width: "150px",
            selector: (row) => {
                return row.Status === 1 ? (<div style={{ minWidth: "100px" }}>
                    <span className="ActionIcon" title="Processed" onClick={() => onAssignOrg(row._id, row.City)}
                        style={{ color: "#147a6f", paddingRight: "20px" }}><FontAwesomeIcon icon={faChalkboardTeacher} /></span>
                    <span className="ActionIcon" title="Discard" onClick={() => OnActionClick(row._id, 3, null)}>
                        <FontAwesomeIcon style={{ color: "#f61414" }} icon={faTrash} /></span>
                </div>) :
                    (<div>{row.Status === 2 ? (<div><span style={{ paddingRight: "20px" }} className="ActionIcon" title="Re-Assign" onClick={() => onAssignOrg(row._id, row.City)}>
                        <FontAwesomeIcon style={{ color: "#00c000" }} icon={faHandshake} /></span>
                        <span className="ActionIcon" title="Close Enquiry" onClick={() => OnCloseEnquiry(row._id)}>
                            <FontAwesomeIcon style={{ color: "#f61414" }} icon={faClipboardCheck} /></span>
                    </div>) : (row.Status === 3 ? "Rejected" : "Closed")}</div>)
            }
        }
    ];

    const onWebSiteClick = (website) => {
        if (website !== "") {
            window.open((website.indexOf("http") === -1 ? "http://" : "") + website);
        }
    };

    const ExpandOrgDetails = ({ data }) => {
        return (
            <div className="row" style={{ margin: "10px" }}>
                <div className={data.Agent.length > 0 ? (data.Partner.length > 0 ? "col-md-4" : "col-md-6") : (data.Partner.length > 0 ? "col-md-6" : "col-md-12")}>
                    <div className={`${CurrentTheme}`} style={{ padding: "5px", color: "white" }}>User Details</div>
                    <table className="table table-bordered">
                        <tbody>
                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                <td>
                                    <h6>Name</h6>
                                </td>
                                <td>
                                    <span>
                                        {data.User[0].FirstName + " " + data.User[0].LastName}
                                    </span>
                                </td>
                            </tr>
                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                <td>
                                    <h6>Phone Number</h6>
                                </td>
                                <td>
                                    <div style={{
                                        padding: "0 10px", borderRadius: "10px",
                                    }}><a style={{ textDecoration: "none" }} href={`tel:+91${data.User[0].PhoneNumber}`}>{data.User[0].PhoneNumber}</a></div>
                                </td>
                            </tr>
                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                <td>
                                    <h6>Email ID</h6>
                                </td>
                                <td>
                                    <span>
                                        <a className="hover-style" href={`mailto:${data.User[0].EmailID}`}>{data.User[0].EmailID}</a>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {data.Partner.length > 0 && (<div className={data.Agent.length > 0 ? (data.Partner.length > 0 ? "col-md-4" : "col-md-6") : (data.Partner.length > 0 ? "col-md-6" : "col-md-12")}>
                    <div className={`${CurrentTheme}`} style={{ padding: "5px", color: "white" }}>Assign To</div>
                    <table className="table table-bordered">
                        <tbody>
                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                <td>
                                    <h6>Name</h6>
                                </td>
                                <td>
                                    <span>
                                        {data.Partner[0].Name}
                                    </span>
                                </td>
                            </tr>
                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                <td>
                                    <h6>Contact</h6>
                                </td>
                                <td>
                                    <div style={{
                                        padding: "0 10px", borderRadius: "10px",
                                    }}><a style={{ textDecoration: "none" }} href={`tel:+91${data.Partner[0].Contact}`}>{data.Partner[0].Contact}</a></div>
                                </td>
                            </tr>
                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                <td>
                                    <h6>Website</h6>
                                </td>
                                <td>
                                    <div style={{ whiteSpace: "normal", cursor: (data.Partner[0].Website === "" ? "default" : "pointer"), color: (data.Partner[0].Website === "" ? "" : "#005582") }} onClick={() => onWebSiteClick(data.Partner[0].Website)}>{data.Partner[0].Website}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>)}
                {data.Agent.length > 0 && (<div className={data.Agent.length > 0 ? (data.Partner.length > 0 ? "col-md-4" : "col-md-6") : (data.Partner.length > 0 ? "col-md-6" : "col-md-12")}>
                    <div className={`${CurrentTheme}`} style={{ padding: "5px", color: "white" }}>Agent Info</div>
                    <table className="table table-bordered">
                        <tbody>
                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                <td>
                                    <h6>Name</h6>
                                </td>
                                <td>
                                    <span>
                                        {`${data.Agent[0].FirstName} ${data.Agent[0].LastName}`}
                                    </span>
                                </td>
                            </tr>
                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                <td>
                                    <h6>Contact</h6>
                                </td>
                                <td>
                                    <div style={{
                                        padding: "0 10px", borderRadius: "10px",
                                    }}>
                                        <a style={{ textDecoration: "none" }} href={`tel:+91${data.Agent[0].PhoneNumber}`}>{data.Agent[0].PhoneNumber}</a>
                                    </div>
                                </td>
                            </tr>
                            <tr style={{ borderBottom: "1px solid #ccc" }}>
                                <td>
                                    <h6>Email ID</h6>
                                </td>
                                <td>
                                    <a className="hover-style" href={`mailto:${data.Agent[0].EmailID}`}>{data.Agent[0].EmailID}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>)}
            </div>
        )
    }

    return (
        <div>
            <Header></Header>
            <div style={{ border: "none", boxShadow: "none" }} className="container-fluid InvoiceTheme sidemenu-show">
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <h5 className="align-center" style={{ fontWeight: "500" }}>Manage Enquiry</h5>
                    </div>
                </div>
                <div className="row dtTable" style={{ padding: "15px" }}>
                    <div style={{ width: "100%", textAlign: "center", border: "1px solid #ccc", borderRadius: "10px" }}>
                        <DataTable
                            columns={columns}
                            data={FilterEnquiry}
                            expandDetails={ExpandOrgDetails}
                        />
                    </div>
                </div>
            </div>
            <div id="AssignEnquiry" className="modal" style={{ display: displayAssignModal }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Assign Partner</span>
                        <span className="close" onClick={hideAssignOrgView}>&times;</span>
                    </div>
                    <div>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td style={{ width: "250px" }}><h4>Organization<span className="mandatoryStar">*</span></h4></td>
                                    <td>
                                        <Select styles={{ borderRadius: "20px" }} isClearable={true} isSearchable={true} placeholder="Select Source Partner"
                                            options={OrgList} onChange={onOrgListChange}></Select>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "right" }} colSpan="5">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <button type="button" style={{ paddingRight: "10px" }} className={`btn btn-General ${CurrentTheme}`} onClick={OnEnquiryProcess}>Process</button>
                                                <button type="button" className="btn btn-default" onClick={hideAssignOrgView}>Close</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Enquiry;